import { stringify } from 'qs';
import func from '../../utils/Func';
import request from '../../utils/request';

// =====================会议室/教室===========================

export async function list(params) {
  return request(`/api/tscloud-eq-interact/room/page?${stringify(params)}`);
}

export async function rooms(params) {
  return request(`/api/tscloud-eq-interact/room/list?${stringify(params)}`);
}

export async function remove(params) {
  return request('/api/tscloud-eq-interact/room/remove', {
    method: 'POST',
    body: func.toFormData(params),
  });
}

export async function add(params) {
  return request('/api/tscloud-eq-interact/room/save', {
    method: 'POST',
    body: params,
  });
}

export async function edit(params) {
  return request('/api/tscloud-eq-interact/room/update', {
    method: 'POST',
    body: params,
  });
}

export async function detail(params) {
  return request(`/api/tscloud-eq-interact/room/detail?${stringify(params)}`);
}
